module.exports = __webpack_public_path__ + "static/media/logo.d69e26f2.png";